<template>
  <div class="leaderboard-share" ref="container">
    <spinner v-if="showSpinner" />
    <div class="inner" ref="share">
      <div class="left-section">
        <!-- <div class="logo-wrapper"><img class="logo" :src="gameContent.vordor_mb_img" alt="" height="37" width="38" /></div> -->
        <img class="share-img" :src="pageContent.image_url" alt="share img" width="425" height="630" />
      </div>
      <div class="right-section">
        <img :src="gameContent.logo" alt="logo" height="53" width="55" />
        <slot></slot>
      </div>
    </div>
    <div class="btn-wrapper">
      <button type="button" class="new-btn-share" @click="share()">{{ pageContent.cta_links[2].text }}</button>
      <button type="button" class="new-btn-share" @click="share(false)">{{ pageContent.cta_links[3].text }}</button>
      <button type="button" class="btn-download" @click="save">{{ pageContent.cta_links[4].text }}</button>
    </div>
  </div>
</template>

<script>
import API from '@/shared/api'
import html2canvas from 'html2canvas'
export default {
  name: 'leaderboardShare',
  props: [
    'userInfo',
    'gameContent',
    'pageContent',
    'mobileView',
  ],
  data () {
    return {
      isMounted: false,
      shareId: null,
      showSpinner: false,
    }
  },
  mounted () {
    window.addEventListener('click', this.handleClickOutside);
  },
  destroyed () {
    window.removeEventListener('click', this.handleClickOutside);
  },
  methods: {
    handleClickOutside (event) {
      if (!this.isMounted) {
        this.isMounted = true
        return
      }
      const ele = this.$refs.container
      if (ele && !ele.contains(event.target)) {
        this.$emit('close')
      }
    },
    inlineSvgUses(svgElement) {
      const uses = svgElement.querySelectorAll('use')
      uses.forEach((use) => {
        const href = use.getAttribute('href') || use.getAttribute('xlink:href')
        const symbolId = href.slice(1)
        const symbol = document.getElementById(symbolId)
        if (symbol) {
          const clonedChildren = Array.from(symbol.children).map(child => child.cloneNode(true))
          clonedChildren.forEach((child) => {
            use.parentNode.insertBefore(child, use)
          });
          use.remove()
        }
      });
    },
    postToFacebook (shareId = '') {
      this.shareId = shareId
      this.showSpinner = false
      const sharePage = `https://www.facebook.com/sharer.php?u=${this.$data.globalData.hosted_domain}share/${shareId}/`;
      window.open(sharePage, '_blank')
      this.$emit('close')
    },
    postToTwitter (shareId = '') {
      this.shareId = shareId
      this.showSpinner = false
      const twitterUrl = `https://twitter.com/share?url=${this.$data.globalData.hosted_domain}share/${shareId}/`;
      window.open(twitterUrl, '_blank')
      this.$emit('close')
    },
    convertToImg (isFacebook = true, isDownload = false) {
      const captureEle = this.$refs.share
      const containerEle = this.$refs.container
      const clonedEle = captureEle.cloneNode(true)
      clonedEle.classList.add('cloned')
      containerEle.appendChild(clonedEle)
      this.inlineSvgUses(clonedEle);
      const leaderBoardInfoEle = clonedEle.querySelector('.leaderboard-info')
      leaderBoardInfoEle.classList.add('cloned')

      html2canvas(clonedEle, {
        scale: 4,
        width: 1200,
        height: 630,
        useCORS: true,
        allowTaint: false,
      }).then((canvas) => {
        canvas.toBlob((blob) => {
          const formData = new FormData()
          formData.append('file', blob, 'leaderboard.png')
          if (isDownload) {
            const imgUrl = URL.createObjectURL(blob)
            this.download(imgUrl)
            return
          }

          API.meInstance.post('/upload-image', formData).then((res) => {
            if (res.data && res.data.image_url) {
              const id = `${res.data.share_id}_leaderboard`
              if (isFacebook) this.postToFacebook(id)
              else this.postToTwitter(id)
            }
          }).catch((err) => {
            console.log(err)
          })
          clonedEle.remove()
          leaderBoardInfoEle.classList.remove('cloned')
        }, 'image/png', 1.0)
      })
    },
    share (isFacebook = true) {
      this.showSpinner = true
      if (this.shareId) {
        if (isFacebook) this.postToFacebook(this.shareId)
        else this.postToTwitter(this.shareId)
        return
      }
      this.convertToImg(isFacebook)
    },
    download (url) {
      if (!url) return
      const a = document.createElement('a')
      a.href = url
      a.download = 'RegluvardarShare_leaderboard.png'
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    },
    save () {
      this.convertToImg(false, true)
    },
  },
}
</script>

<style lang="scss" scoped>
.leaderboard-share {
  padding: 20px;
  background: #F8F8F8;
  border-radius: 10px;
  margin: 20px;
  position: relative;
  max-height: 95%;
  overflow: auto;
  .spinner-wrap {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 9;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.13);
  }
  .inner {
    display: flex;
    box-shadow: 0px 0px 50px 0px rgba(0, 0, 0, 0.1);
    max-width: 913px;
    width: 100%;
    margin: 0 auto 39px;
    &.cloned {
      position: fixed;
      flex-direction: row;
      bottom: 300%;
      .left-section {
        flex: 1 0 425px;
        .share-img {
          height: 630px;
          max-width: none;
        }
      }
      .right-section {
        flex: 1 0 775px;
      }
    }
    .left-section {
      position: relative;
      .logo-wrapper {
        position: absolute;
        top: 0;
        left: 0;
        height: 73px;
        width: 78px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #011627;
      }
      .share-img {
        height: 100%;
        width: 100%;
        max-width: 300px;
      }
    }
    .right-section {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      padding: 36px 57px 36px 55px;
      background: #FFFFFF;
      position: relative;
      /deep/.leaderboard-info {
        margin-top: 0;
        .player-profile {
          gap: 8px;
          margin-bottom: 27px;
        }
        .related-info {
          padding: 33.5px 16px;
          margin-bottom: 0;
        }
      }
      img {
        position: absolute;
        top: 13px;
        right: 11px;
        height: 53px;
        width: 55px;
      }
    }
  }
  .btn-wrapper {
    display: flex;
    align-items: center;
    gap: 25px;
    max-width: 913px;
    width: 100%;
    margin: 0 auto;
    button {
      height: 50px;
      border-radius: 10px;
      font-weight: 500;
      color: #011627;
      max-width: 408px;
      width: 100%;
      margin: 0 auto;
    }
    .new-btn-share, .btn-download {
      border: 1.5px solid #FCBD00;
      background: #FFFFFF;
      box-shadow: 0px 0px 50px 0px #0000001A;
    }
    .btn-play {
      background: #FCBD00;
      border: none;
    }
  }
}

@media screen and (max-width: 998px) {
  .leaderboard-share {
    padding: 20px;
    .inner:not(.cloned) {
      .right-section {
        padding: 36px 20px;
      }
    }
  }  
}

@media screen and (max-width: 768px) {
  .leaderboard-share {
    margin-top: calc(var(--mobile-header-height) + 20px);
  }
}

@media screen and (max-width: 767px) {
  .leaderboard-share {
    padding: 20px;
    overflow: auto;
    max-height: calc(100dvh - var(--mobile-header-height) - 50px);
    .inner:not(.cloned) {
      flex-direction: column;
      margin-bottom: 20px;
      .left-section {
        max-width: 100%;
        .share-img {
          width: 100%;
          max-width: none;
        }
      }
      .right-section {
        padding: 36px 10px;
        /deep/.leaderboard-info {
          .related-info {
            padding: 20px 2px;
          }
        }
      }
    }
    .btn-wrapper {
      flex-direction: column;
      gap: 10px;
      width: 100%;
    }
  }
}
</style>
